import React, { useState } from 'react';
import { Breadcrumb, Input, Button, Form, message, Row, Col, Select ,List} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
const { TextArea } = Input;
const MemberItem = (props) => {
    const navigate = useNavigate();
    const [isShowEdit, setShowEdit] = useState(false)
    
    React.useEffect(() => {

    }, [])
    
    return (
        <div onMouseDown={props.remove(props.name)} onMouseOut={setShowEdit(true)} onMouseOver={setShowEdit(false)}style={{ height: '30px',textAlign:'center' }}>
          {props.name} 
        </div>
    );

}

export default MemberItem